// Only an explicit portal entry may leave the main dashboard's account-access flow.
// GrooveSell owns this history route; the main dashboard uses hash routing.
export function getGrooveSellDestination(value, origin) {
  if (!value) return null;
  try {
    const url = new URL(value, origin);
    if (url.origin !== origin || url.username || url.password ||
        !/^\/groovesell\/promo-tools\/[A-Za-z0-9_-]+\/?$/.test(url.pathname)) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch (_) {
    return null;
  }
}

export function getAffiliateLanding({ route, origin }) {
  return getGrooveSellDestination(route.fullPath, origin);
}
